import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { Brain, Heart, Users, BookOpen, Calendar, MessageCircle, Home, Menu } from 'lucide-react';

// Pages
import HomePage from './pages/HomePage';
import ResourcesPage from './pages/ResourcesPage';
import CommunityPage from './pages/CommunityPage';
import ToolsPage from './pages/ToolsPage';
import BlogPage from './pages/BlogPage';
import CoursesPage from './pages/CoursesPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        {/* Navigation */}
        <nav className="bg-gradient-to-r from-teal-600 to-emerald-600 text-white shadow-lg sticky top-0 z-50">
          <div className="container mx-auto px-4 py-4">
            <div className="flex justify-between items-center">
              <Link to="/" className="text-2xl font-bold flex items-center">
                <Brain className="mr-2" />
                ADHD Life Online
              </Link>
              <div className="hidden md:flex space-x-6">
                <Link to="/" className="hover:text-teal-200 transition flex items-center">
                  <Home className="mr-1" size={18} /> Home
                </Link>
                <Link to="/resources" className="hover:text-teal-200 transition flex items-center">
                  <BookOpen className="mr-1" size={18} /> Resources
                </Link>
                <Link to="/blog" className="hover:text-teal-200 transition flex items-center">
                  <BookOpen className="mr-1" size={18} /> Blog
                </Link>
                <Link to="/courses" className="hover:text-teal-200 transition flex items-center">
                  <Brain className="mr-1" size={18} /> Courses
                </Link>
                <Link to="/community" className="hover:text-teal-200 transition flex items-center">
                  <Users className="mr-1" size={18} /> Community
                </Link>
                <Link to="/tools" className="hover:text-teal-200 transition flex items-center">
                  <Brain className="mr-1" size={18} /> Tools
                </Link>
                <Link to="/about" className="hover:text-teal-200 transition flex items-center">
                  <Heart className="mr-1" size={18} /> About
                </Link>
                <Link to="/contact" className="hover:text-teal-200 transition flex items-center">
                  <MessageCircle className="mr-1" size={18} /> Contact
                </Link>
              </div>
              <div className="flex items-center space-x-4">
                <Link to="/login" className="hover:text-teal-200 transition">Login</Link>
                <Link to="/register" className="bg-white text-teal-700 px-6 py-2 rounded-full font-semibold hover:bg-teal-50 transition">
                  Join Now
                </Link>
              </div>
              <button className="md:hidden">
                <Menu size={24} />
              </button>
            </div>
          </div>
        </nav>

        {/* Main Content */}
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/resources" element={<ResourcesPage />} />
            <Route path="/community" element={<CommunityPage />} />
            <Route path="/tools" element={<ToolsPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/courses" element={<CoursesPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
          </Routes>
        </main>

        {/* Footer */}
        <footer className="bg-gray-900 text-white py-12 mt-20">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
              <div>
                <h3 className="text-xl font-bold mb-4 flex items-center">
                  <Brain className="mr-2" /> ADHD Life Online
                </h3>
                <p className="text-gray-400">
                  Your trusted companion for living well with ADHD. Support, resources, and community.
                </p>
              </div>
              <div>
                <h4 className="font-bold mb-4">Quick Links</h4>
                <ul className="space-y-2 text-gray-400">
                  <li><Link to="/resources" className="hover:text-teal-400">Resources</Link></li>
                  <li><Link to="/community" className="hover:text-teal-400">Community</Link></li>
                  <li><Link to="/tools" className="hover:text-teal-400">Tools</Link></li>
                  <li><Link to="/about" className="hover:text-teal-400">About Us</Link></li>
                </ul>
              </div>
              <div>
                <h4 className="font-bold mb-4">Support</h4>
                <ul className="space-y-2 text-gray-400">
                  <li><Link to="/faq" className="hover:text-teal-400">FAQ</Link></li>
                  <li><Link to="/contact" className="hover:text-teal-400">Contact</Link></li>
                  <li><Link to="/crisis" className="hover:text-teal-400">Crisis Help</Link></li>
                  <li><Link to="/professionals" className="hover:text-teal-400">Find Professionals</Link></li>
                </ul>
              </div>
              <div>
                <h4 className="font-bold mb-4">Connect</h4>
                <ul className="space-y-2 text-gray-400">
                  <li>📧 support@adhdlifeonline.com</li>
                  <li>📞 1-800-ADHD-HELP</li>
                  <li>💬 24/7 Support Chat</li>
                </ul>
              </div>
            </div>
            <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
              <p>&copy; 2026 ADHD Life Online. All rights reserved.</p>
            </div>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;